import { IncidentFormValues, ReviewOutcome, ReviewStatus, ReviewSubjectType } from '../../../types';
import { convertDateToTimezone } from '../../../date.utils';
import { environment } from 'src/environments/environment';

export function reviewOutcomeToFormValues(reviewOutcome: ReviewOutcome): IncidentFormValues {
  const existingExtraLinks = reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'VideoLink').length > 0;
  const existingUniqueInstancePhotos = reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'InstancePhoto').length > 0;
  const existingReports = reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'ReportImage').length > 0;
  const selectedImages =
    reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'RecentWalkInSnapshot').map((l) => l.link as string) ?? [];
  return {
    isTheft: reviewOutcome.keystore_parsed.is_theft ?? false,
    reviewOutcomeId: reviewOutcome.review_outcome_id,
    comments: reviewOutcome.comments ?? '',
    commentsRating: 0,
    suspectedItems: null,
    matchingCase: reviewOutcome.case_id ?? 'new_case',
    additionalStolenValue: reviewOutcome.keystore_parsed.item_cancellation_value ?? 0,
    instance_at: reviewOutcome.instance_at ? convertDateToTimezone(reviewOutcome.instance_at, reviewOutcome.location_timezone) : null,
    theftType: {
      is_cancellation: reviewOutcome.keystore_parsed?.theft_type?.is_cancellation ?? false,
      is_underringing: reviewOutcome.keystore_parsed?.theft_type?.is_underringing ?? false,
      is_walkout: reviewOutcome.keystore_parsed?.theft_type?.is_walkout ?? false,
      is_cashier: reviewOutcome.keystore_parsed?.theft_type?.is_cashier ?? false,
    },
    uniqueInstancePhoto: null,
    reports: null,
    existingUniqueInstancePhoto: existingUniqueInstancePhotos
      ? reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'InstancePhoto').map((l) => l.link as string)
      : [],
    existingReports: existingReports
      ? reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'ReportImage').map((l) => l.link as string)
      : [],
    extraLinks: existingExtraLinks ? reviewOutcome.attachments_parsed?.filter((a) => a.link_type === 'VideoLink').map((l) => l.link) : [''],
    didNotReturn: selectedImages.length > 0,
    selectedImages: selectedImages,
    useKioskPhoto: reviewOutcome.keystore_parsed?.use_kiosk_photo ?? false,
  };
}

export function parseReviewSubjectType(input: string): ReviewSubjectType {
  if (!input) throw new Error('Input string cannot be empty');
  const normalizedInput = input.trim();
  const matchingType = Object.values(ReviewSubjectType).find((type) => type === normalizedInput);
  if (matchingType) return matchingType;
  throw new Error(`No matching ReviewSubjectType for: "${input}"`);
}

export function parseReviewStatus(value: string | null | undefined): ReviewStatus | undefined {
  if (!value) return undefined;

  const normalized = value.toLowerCase();
  switch (normalized) {
    case ReviewStatus.Created:
      return ReviewStatus.Created;
    case ReviewStatus.Assigned:
      return ReviewStatus.Assigned;
    case ReviewStatus.Pending:
      return ReviewStatus.Pending;
    case ReviewStatus.Completed:
      return ReviewStatus.Completed;
    case ReviewStatus.Validated:
      return ReviewStatus.Validated;
    case ReviewStatus.Abandoned:
      return ReviewStatus.Abandoned;
    case ReviewStatus.Error:
      return ReviewStatus.Error;
    default:
      return undefined;
  }
}

export function getLpReviewUrl(assignmentId: string): string {
  return `${environment.lpBaseUrl}/review/micromarket/${assignmentId}`;
}
